export default __webpack_public_path__ + "static/media/Mia Smith - 1.264d3c2f.jpg";